import { useState, useEffect, useRef, createRef } from 'react'

export const useDefaultGrid = (props: any) => {
    const [docheck, setDocheck] = useState(false)
    const [firstcheck, setFirstcheck] = useState(false)
    const [withoutEdit, setWithoutEdit] = useState(props.withoutEdit || false)
    const [editDdl, setEditDdl] = useState<any>(null)
    const [editDdi, setEditDdi] = useState<any>(null)
    const [editDddf, setEditDddf] = useState<any>(null)
    const [editDf, setEditDf] = useState<any>(null)

    const ddiRefs = useRef<{ [key: string]: any }>({})

    useEffect(() => {
        props.items.forEach((item: any) => {
            if (!ddiRefs.current[`ddiRef${item.id}`]) {
                ddiRefs.current[`ddiRef${item.id}`] = createRef<any>()
            }
        })
    }, [props.items])

    const doFocus = (errorId: string) => {
        const ref = ddiRefs.current[`ddiRef${errorId}`]
        if (!ref || !ref.current || !ref.current.ddiRef) {
            return
        }
        ref.current.ddiRef.current.doFocus(errorId)
    }

    const onCancel = () => {
        const filtered = props.items.filter(
            (item: any) => item.view === 'edit' || item.view === 'show/edit'
        )
        filtered.forEach((filterItem: any) => {
            if (
                (filterItem.def_dossier_link &&
                    filterItem.def_dossier_link.type_of_link === 'select') ||
                (filterItem.def_dossier_def_field &&
                    filterItem.def_dossier_def_field.def_field &&
                    (filterItem.def_dossier_def_field.def_field.type ===
                        'user' ||
                        filterItem.def_dossier_def_field.def_field.type ===
                            'list'))
            ) {
                const inner =
                    ddiRefs.current[`ddiRef${filterItem.id}`]?.current?.ddiRef
                        ?.current
                if (typeof inner?.onCancel === 'function') {
                    inner.onCancel()
                }
            }
        })
    }

    const getValues = () => {
        const values: { [key: string]: any } = {}
        const filtered = props.items.filter(
            (item: any) => item.view === 'edit' || item.view === 'show/edit'
        )
        filtered.forEach((filterItem: any) => {
            const ref = ddiRefs.current[`ddiRef${filterItem.id}`]
            if (
                ref &&
                ref.current &&
                ref.current.ddiRef &&
                ref.current.ddiRef.current &&
                ref.current.ddiRef.current.getValue
            ) {
                values[filterItem.id] = ref.current.ddiRef.current.getValue()
            }
        })
        return values
    }

    const recheckConditions = () => {
        setDocheck(!docheck)
    }

    return {
        docheck,
        firstcheck,
        withoutEdit,
        editDdl,
        editDdi,
        editDddf,
        editDf,
        ddiRefs,
        doFocus,
        onCancel,
        getValues,
        recheckConditions,
        setFirstcheck,
        setEditDdl,
        setEditDdi,
        setEditDddf,
        setEditDf,
    }
}
